<style>

</style>
<template>
<div id="projects">

   <body>

<h3><font size="5">Projects + Volunteer Work</font></h3>

    <p>
      <strong> RadiumSix - Contact Tracing </strong>
        <br> <u>Intern | Aug 2019 – current </u>
        <br> • Responsible for integrating web dashboard based on AWS analytics component.
        <br> • Developed use cases and test cases for mobile app to cloud interface.
        <br> • Worked on emerging technology features for app.
        <br> • Technology Stack: AWS, Codecommit, Vue.js, Cloud Formation, Jira, Confluence, Node.js (Lambda).
        <br>
      <a href="https://radiumsix.com" target="_blank">RadiumSix.com</a>
    </p>
    
    <p>
      <strong> Ace on The Case (Game) </strong>
        <br> <u>Programmer and Tester | Aug 2019 – current </u>
        <br>• Built an educational mobile game app aimed at children ages 5 - 7 that is designed to <br> encourage development and problem-solving skills through the use <br> of puzzles and interactive storytelling.
        <br>• Applied industry standard software quality principles. 
        <br>• Applied requisite game related design, development, and deployment activities.
        <br>• Conducted use case analysis and testing.
        <br>• Technology Stack: Android Studio, Java.
        <br>
        <a href="https://drive.google.com/file/d/12g6GrplD5Qhj1xYhXy7DqVHN4sWRpEgD/view?usp=sharing" target="_blank">See Project</a>
    </p>

    <p>
        <br> <strong> Mental Health Through AI and Learning Technology - Mobile Application </strong>
        <br> <u>UI Designer | Aug 2019 - April 2020</u>
        <br> • Design a gamified app to improve the user’s mental health.
        <br> • Designed graphic user interface elements, like menus, tabs and widgets.
        <br> • Built page navigation buttons and search fields.
        <br> • Developed using style standards on fonts, colors and images. <br>

        <a href="https://drive.google.com/drive/folders/1llqsh7VXe0OpO5zNrZzyfH9YOLukoqIr?usp=sharing" target="_blank">See Project</a>
    </p>

    <p>
        <br> <strong> Personal Brand Web Application </strong>
        <br> • Developed a full stack web application showcasing myself and experience utilizing a js-framework and AWS cloud.
        <br> • Used Visual Studio Code as a choice of source-code editor.
        <br> • Used AWS S3 bucket to host static site and code commit for the repository.
        <br> • Built CICD pipeline to automate deployment.
    </p>

    <p> 
        <br> <strong> Lakeland Habitat for Humanity Volunteer </strong> 
        <br> Weekly volunteer assisting in the building of affordable homes for families. <br>
        <a href="https://drive.google.com/file/d/1i6p2_o1xR_n0A5fVaWAbUH7A15tVGhXE/view?usp=sharing" target="_blank">Volunteer Video</a>
    </p>


</body>
</div>
</template>

<script>
   export default{

   }
</script>

<style scoped>
body {
    background: #e9e2d5;
    padding: 30px;
}
p{
    color: black;
    font-size: 20px;

}
</style>